import { DocumentType, DocumentTypeWithVirtual, ValueOf } from 'support/types';

export const mapVirtualToActualDocumentType = (
  documentType: ValueOf<DocumentTypeWithVirtual> | undefined,
): DocumentType | undefined => {
  if (!documentType) {
    return undefined;
  }
  switch (documentType) {
    case DocumentTypeWithVirtual.orderConfirmation:
    case DocumentTypeWithVirtual.partialOrderConfirmation:
    case DocumentTypeWithVirtual.orderRejection:
      return DocumentType.orderResponse;
    case DocumentTypeWithVirtual.serviceInvoice:
    case DocumentTypeWithVirtual.debitNote:
      return DocumentType.invoice;
    default:
      return documentType as unknown as DocumentType;
  }
};

export const useMapVirtualToActualDocumentType = (
  documentType: ValueOf<DocumentTypeWithVirtual> | undefined,
): DocumentType | undefined => {
  return mapVirtualToActualDocumentType(documentType);
};

const DOCUMENT_TYPES_WITH_TRANSPORT_UNITS = [
  DocumentType.shippingNotice,
  DocumentType.dispatchResponse,
  DocumentType.receivalNotice,
];

export const isDocumentTypeWithTransportUnits = (documentType: DocumentType): boolean => {
  return DOCUMENT_TYPES_WITH_TRANSPORT_UNITS.includes(documentType);
};

const DOCUMENT_TYPES_WITH_LOCATIONS = [DocumentType.salesReport];
export const isDocumentTypeWithLocations = (documentType: DocumentType): boolean => {
  return DOCUMENT_TYPES_WITH_LOCATIONS.includes(documentType);
};
